import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { useBusinessNumber } from '../../../../shared/hooks/useBusinessNumber.js';

interface ApiMetricRow {
  readonly apiMonitorId: string;
  readonly endpoint: string;
  readonly healthStatus: string;
  readonly availabilityPct: string;
  readonly failureRatePct: string;
}

export function M19MonitoringDashboardPage(): ReactNode {
  const { decimal } = useBusinessNumber();
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<ApiMetricRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: ApiMetricRow[] }>('/v1/platform/monitoring/api', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m19.monitoring.loading')}</p>;
  return (
    <main aria-label="monitoring-dashboard">
      <h1>{t('m19.monitoring.title')}</h1>
      <table aria-label="api-metrics-table">
        <thead><tr><th>{t('m19.monitoring.colEndpoint')}</th><th>{t('m19.monitoring.colHealth')}</th><th>{t('m19.monitoring.colAvailability')}</th><th>{t('m19.monitoring.colFailure')}</th></tr></thead>
        <tbody>
          {rows.map((m) => (
            <tr key={m.apiMonitorId}>
              <td>{m.endpoint}</td>
              <td>{m.healthStatus}</td>
              <td>{decimal(m.availabilityPct)}</td>
              <td>{decimal(m.failureRatePct)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
